<template>
  <div id="body-content">
    <Card id="winter-1" />
    <Video id="winter-2" />
    <Motion id="winter-3" />
    <Legals id="winter-4" />
  </div>
</template>

<script>
import Card from './components/Card'
import Video from './components/Video'
import Motion from './components/Motion'
import Legals from './components/Legals'

export default {
  name: 'App',
  components: {
    Card,
    Video,
    Motion,
    Legals
  }
}
</script>

<style lang="scss">
  @import "./assets/style";

  #winter-main-content {
    @media all and (min-width: 1025px) {
      background: url('./assets/images/line.png') top 200rem center no-repeat;
    }
  }

  #winter-3 {
    background: url('./assets/images/background-winter-main.jpg') no-repeat bottom left #bbdbe3;
  }

  #footer_tc_privacy_text p {
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue